enum AppFeatures {
    Scan,
    AcceptOrder,
    DenyOrder,
    CompleteOrder,
    OrderOverview,
    OrderMaker,
    JwsOverview
}

export default AppFeatures;